module.exports = __webpack_public_path__ + "static/media/account-primary-dark.ef601c66.svg";